import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconButton from '@material-ui/core/IconButton';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import NotificationIconButton from 'Components/UI/Notifications/IconButton';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import InfoCircle from 'Icons/InfoCircle';
import { advisorResourcesPath } from 'Consts/advisorUris';
import useUserContext from 'Context/UserContext';
import modalConsts from 'Consts/ModalNames';
import { openModal } from 'Helpers/ModalHelper';
import './index.css';
import IslandIcon from 'Icons/IslandIcon';
import { noop } from 'Helpers/PropTypes';
import { useLogoutContext } from 'Context/LogoutContext';

// TODO: MOVE ALL OTHER STYLES (from: './index.css') HERE
const styles = (theme) => ({
  root: {},
  iconButton: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.grey[400],
  },
  outOfOfficeButton: {
  },
});

const HeaderActions = ({
  classes,
  className,
  showLogout,
  showNotifications,
  showResources,
  clearHousehold,
  onOutOfOfficeClick,
}) => {
  const { agentResource } = useUserContext();
  const { logout } = useLogoutContext();
  const { rootNodeProps } = useEventTrackingLogEvent();

  const OutOfOfficeActionUpdate = () => (
    <IconButton
      test={'open-out-of-office-dialog-button'}
      className={classNames(classes.outOfOfficeButton, classes.iconButton)}
      onClick={() => openModal(modalConsts.outOfOfficeModal, [{ outOfOfficeSelfLink: agentResource?.relationship(fr.relationships.outOfOffice.name).link('related').url() }])}
    >
      <IslandIcon
        color={agentResource.attr('outOfOffice') === 'true' ? 'primary' : undefined}
      />
    </IconButton>
  );

  const OutOfOfficeActionComponent = OutOfOfficeActionUpdate;
  const outOfOfficeActionProps = {};

  return (
    <div
      className={classNames('header-actions', className)}
      {...rootNodeProps}
    >
      {(agentResource && onOutOfOfficeClick && OutOfOfficeActionComponent) && (
        <OutOfOfficeActionComponent {...outOfOfficeActionProps} />
      )}
      {showResources && (
        <IconButton className="icon" component={Link} to={advisorResourcesPath}>
          <InfoCircle height="30px" width="30px" />
        </IconButton>
      )}
      <NotificationIconButton hidden={!showNotifications} />
      {showLogout && (
        <IconButton
          test="sign-out"
          className="icon sign-out-icon"
          onClick={() => {
            logout();
            clearHousehold();
          }}
        >
          <FontAwesome icon="sign-out" fontSize="32px" />
        </IconButton>
      )}
    </div>
  );
};

HeaderActions.defaultProps = {
  showResources: false,
  showNotifications: true,
  showLogout: true,
  nextMeeting: null,
  className: '',
  clearHousehold: () => { },
  onOutOfOfficeClick: null,
  logout: noop,
};

HeaderActions.propTypes = {
  className: PropTypes.string,
  showResources: PropTypes.bool,
  showLogout: PropTypes.bool,
  nextMeeting: PropTypes.object,
  showNotifications: PropTypes.bool,
  logout: PropTypes.func,
  clearHousehold: PropTypes.func,
  onOutOfOfficeClick: PropTypes.func,
};

export default withStyles(styles)(HeaderActions);
